import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.5,0h-7A1.5,1.5,0,0,0,0,1.5v7A1.5,1.5,0,0,0,1.5,10h7A1.5,1.5,0,0,0,10,8.5v-7A1.5,1.5,0,0,0,8.5,0ZM4.354,6.343l-1.5,1.5a.5.5,0,0,1-.708-.707L3.293,5.989,2.146,4.843a.5.5,0,1,1,.708-.707l1.5,1.5A.5.5,0,0,1,4.354,6.343ZM7.5,6.489H6a.5.5,0,0,1,0-1H7.5a.5.5,0,0,1,0,1ZM9,1.75A.25.25,0,0,1,8.75,2H1.25A.25.25,0,0,1,1,1.75V1.5A.5.5,0,0,1,1.5,1h7a.5.5,0,0,1,.5.5Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }